import { ApiResponse } from '@/types/common';
import {
  WalletFilterParams,
  WalletInfoCount,
  WalletTransactionsResponse,
  WalletUpload,
} from '@/types/wallet.type';
import api from '../instance';

export const walletService = {
  createWallets: async (data: WalletUpload) => {
    try {
      const res = await api.walletApi.post('/wallet/create', data, {
        headers: {
          'x-show-loader': true,
          'X-Mm-Service': 'mm-wallet-mgmt-svc',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error creating wallet');
    }
  },

  getWalletList: async (filters?: WalletFilterParams): Promise<WalletTransactionsResponse> => {
    try {
      const res = await api.walletApi.get<WalletTransactionsResponse>(`/wallet/getall`, {
        params: filters,
        headers: {
          'x-show-loader': true,
          'X-Mm-Service': 'mm-content-mgmt-svc',
        },
      });
      return res.data;
    } catch (error) {
      if (error instanceof Error) throw error;
      throw new Error('Error getting wallet list');
    }
  },

  getWalletInfoCount: async () => {
    try {
      const res = await api.walletApi.get<ApiResponse<WalletInfoCount>>('/wallet/totalcount', {
        headers: {
          'x-show-loader': true,
          'X-Mm-Service': 'mm-content-mgmt-svc',
        },
      });
      return res.data;
    } catch (error) {
      if (error instanceof Error) throw error;
      throw new Error('Error getting wallet info count');
    }
  },

  exportWallets: async (params?: Record<string, any>) => {
    try {
      const res = await api.walletApi.get('/wallet/bulk-export', {
        responseType: 'blob',
        params, // send filters here
      });
      return res.data;
    } catch (error) {
      if (error instanceof Error) throw error;
      throw new Error('Error exporting wallets');
    }
  },
};
